var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StackedBarChart',{attrs:{"chart-data":_vm.rateAgentTimeLineChartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }